import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, CircularProgress, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaymentIcon from '@mui/icons-material/Payment';
import PrintIcon from '@mui/icons-material/Print';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CancelIcon from '@mui/icons-material/Cancel';

const getStatusChip = (status) => {
  switch (status) {
    case 'ordered':
      return { label: 'Bestellt', color: 'primary', icon: <ShoppingCartIcon /> };
    case 'paid':
      return { label: 'Bezahlt', color: 'success', icon: <CheckCircleIcon /> };
    case 'payment pending':
      return { label: 'Zahlung ausstehend', color: 'warning', icon: <PaymentIcon /> };
    case 'printed':
      return { label: 'Gedruckt', color: 'info', icon: <PrintIcon /> };
    case 'shipped':
      return { label: 'Versandt', color: 'secondary', icon: <LocalShippingIcon /> };
    case 'delivered':
      return { label: 'Zugestellt', color: 'success', icon: <CheckCircleIcon /> };
    case 'cancelled':
      return { label: 'Storniert', color: 'error', icon: <CancelIcon /> };
    default:
      return { label: 'Unbekannt', color: 'default', icon: <CircularProgress size="small" /> };
  }
};

const OrdersTable = ({ printJobs }) => {
  return (
    <Box sx={{ ml: '1rem', mr: '1rem', mb: '2rem'}}>
      {printJobs.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Schullogbuch</TableCell>
                <TableCell>Auftragsnummer</TableCell>
                <TableCell>Bearbeitungsstatus</TableCell>
                <TableCell>Anzahl Exemplare</TableCell>
                <TableCell>Gesamtbetrag</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {printJobs.map((printJob) => {
                const { label, color, icon } = getStatusChip(printJob.status);
                return (
                  <TableRow key={printJob._id}>
                    <TableCell>{printJob.bookName}</TableCell>
                    <TableCell>{printJob.jobId}</TableCell>
                    <TableCell>
                      <Chip label={label} color={color} icon={icon} variant="outlined" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}/>
                    </TableCell>
                    <TableCell>{printJob.copies}</TableCell>
                    <TableCell>{printJob?.finalPrice?.toFixed(2)} €</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" color="textSecondary" style={{ marginTop: '20px' }}>
          Keine Aufträge verfügbar.
        </Typography>
      )}
    </Box>
  );
};

export default OrdersTable;
